'use client'

import { Pill } from '@repo/ui/Pill'
import type { AccountingBasis } from '../types'

export type AccountingBasisPillProps = {
  accountingBasis: AccountingBasis
}

const LABELS: Record<AccountingBasis, string> = {
  Accruals: 'Accruals',
  Cash: 'Cash basis'
}

// Neutral classification colours (not a success/failure signal) — Accruals is the MTD
// ITSA default so it takes the "standard" secondary.main treatment used elsewhere for a
// default/active state (see MatterStatusPill's 'Open'); Cash (the simplified alternative)
// takes the same muted treatment MatterStatusPill uses for its non-default state.
const COLOURS: Record<AccountingBasis, { color: string; backgroundColor: string }> = {
  Accruals: { color: 'white', backgroundColor: 'secondary.main' },
  Cash: { color: 'black', backgroundColor: 'background.mid' }
}

export const AccountingBasisPill = ({ accountingBasis }: AccountingBasisPillProps) => {
  const { color, backgroundColor } = COLOURS[accountingBasis]

  return (
    <div data-testid="AccountingBasisPill">
      <Pill label={LABELS[accountingBasis]} color={color} backgroundColor={backgroundColor} />
    </div>
  )
}
